import type { ModelFavoriteButtonProps } from "./model-favorite-button.type";

import { StarOutlined, StarFilled } from "@ant-design/icons";
import { Button, Tooltip, Spin } from "antd";
import { useTranslation } from "react-i18next";

import { useModelToggleFavorite } from "@/modules/model-favorite";

const ModelFavoriteButton = ({
  modelKey,
  item,
  ...buttonProps
}: ModelFavoriteButtonProps) => {
  const { t } = useTranslation();

  const id = item?.id ?? 0;
  const isFavorite = item?.favorite ?? false;

  const { mutate, isPending } = useModelToggleFavorite({ modelKey, id });

  const disabled = buttonProps.disabled || !id;
  const loading = buttonProps.loading || isPending;

  const title = isFavorite
    ? t(`global:removeFavorite`)
    : t(`global:addFavorite`);

  const onButtonClick = () => {
    mutate();
  };

  return (
    <Spin spinning={loading}>
      <Tooltip title={title} placement="bottom">
        <Button
          {...buttonProps}
          loading={loading}
          disabled={disabled}
          aria-label={title}
          icon={
            isFavorite ? (
              <StarFilled style={{ color: "green" }} />
            ) : (
              <StarOutlined style={{ color: "gray" }} />
            )
          }
          onClick={onButtonClick}
        />
      </Tooltip>
    </Spin>
  );
};

export default ModelFavoriteButton;
